import React from "react";
import DOMPurify from "dompurify";
import parse from "html-react-parser";
import "react-quill/dist/quill.snow.css";
import {connect} from "react-redux";
import {PlusOutlined} from "@ant-design/icons";
import {Button, Result, Upload} from "antd";
import {Redirect, withRouter} from "react-router-dom";
import IdleTimer from "react-idle-timer";
import {FormStepsActions, KYCActions} from "@redux";
import {ContentLoader, KYCFormSwitchWithSteps, SigningOld, UserActive} from "@components";
import {
    checkJsonExist,
    getClassificators,
    getClassificatorsConst,
    i18,
    translationGroups,
    trb
} from "@utilities";
import PdfDocView from "@components/PdfDocument/PdfDocView";
import {
    decorators,
    getMapDataObject,
    getPrefilledDataObject,
    initData,
    remapNewValues
} from "./Utilities";
import {FillOrgStructure} from "./Components/FillOrgStructure";
import {
    LOGIN_TYPES,
    STORAGE_ITEMS,
    APP_STATES,
    SESSIONS_STORAGE_ITEMS,
    APP_ACTIONS,
    LANGUAGES,
    routerPath,
} from "@config";
import {BioDocUploadModal} from "./Components/BioDocUploadModal";
import {UploadRequestedAppDocs} from "./Components/UploadRequestedAppDocs";
import {StartDocSigning} from "./Components/StartDocSigning";
import {KycComplete} from "./Components/KycComplete";
import {ApplicationsActions} from "../../Redux";
import _ from "lodash";
import Modal from "antd/lib/modal/Modal";

class ApplicationKYCSmeContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            nextAction: null,
            fillOrgStructure: false,
            modalUpload: null,
            modalSubmitAction: null,
            fileList: [],
            existingFileList: [],
            groupedDocumentList: {},
            orgStructure: null,
            orgStructureHtml: null,
            orgStructurePdf: null,
            signingData: null,
            documentId: null,
            finalData: null,
            successSigning: null,
            successFinish: null,
            successRenewFinish: null,
            now: null,
            open: false,
            prefillData: null,
            isBioFaceUploadModalOpen: false,
            isInactiveModalOpen: false,
            timeoutPeriod: undefined,
            applicationId: null,
            isFirst: true,
            showPdf: false,
            list: []
        };
        this.onSubmit = this.onSubmit.bind(this);
    }
    
    componentDidMount = () => {
        const {dispatch} = this.props;
        this.setInactiveModalTimeoutPeriod();
        dispatch(KYCActions.startKYC());
    };
    
    componentDidUpdate = async (prevProps, prevState) => {
        const {applicationKYC, send, signingData} = this.props;
        if (this.state.isFirst && applicationKYC !== prevProps.applicationKYC && applicationKYC) {
            this.setState({
                isFirst: false,
                applicationId: applicationKYC.applicationState.applicationId
            })
            try {
                await this.uploadedDocumentsList(applicationKYC.applicationState.applicationId);
            } catch (e) {
                console.log(e)
            }
        }
        if (send !== prevProps.send && !send && applicationKYC && !signingData) {
            this.actionSwitch();
        }
    };
    
    setInactiveModalTimeoutPeriod = () => {
        const userSession = JSON.parse(sessionStorage.getItem(SESSIONS_STORAGE_ITEMS.USER));
        // 0.1 to get 10% of token value, if no token default is 5 mins
        const timeOutTimeInMs = userSession?.timeValid * 0.1 * 1000 || 1000 * 60 * 5;
        this.setState({
            timeoutPeriod: timeOutTimeInMs
        });
    };
    
    uploadSubmit = async (applicationDocumentId = "") => {
        const {dispatch} = this.props,
            {fileList, orgStructure, orgStructureHtml, modalSubmitAction, orgStructurePdf} = this.state,
            formData = new FormData();
        if (
            fileList.filter(
                item => !applicationDocumentId || item.applicationId === applicationDocumentId
            ).length
        ) {
            fileList
                .filter(item => !applicationDocumentId || item.applicationId === applicationDocumentId)
                .forEach((item, index) => {
                    formData.append("files", item);
                });
            await dispatch(modalSubmitAction(formData, applicationDocumentId)).then((response) => {
                if (response?.type === 'UPLOAD_ARTICLES_OF_ASSOCIATION_SUCCESS') {
                    this.setState({
                        list: response.payload?.applicationDocumentsList
                    })
                }
            });
        } else if (orgStructure && orgStructureHtml) {
            formData.append("jsonData", JSON.stringify(orgStructure));
            formData.append("files", orgStructurePdf);
            dispatch(modalSubmitAction(formData, applicationDocumentId));
        }
    };
    
    filePreview = (file) => {
        if (!this.state.showPdf && !file.size) {
            this.setState({
                documentId: file.uid
            })
            setTimeout(() => {
                this.setState({
                    showPdf: true
                })
            })
        } else {
            this.setState({
                documentId: null,
                showPdf: false
            })
        }
    }
    
    removeFileFromList = file => {
        this.setState(state => {
            const index = state.fileList.indexOf(file),
                newFileList = state.fileList.slice();
            newFileList.splice(index, 1);
            const newExistingFileList = state.existingFileList.slice();
            newExistingFileList.splice(index, 1);
            return {
                fileList: newFileList,
                existingFileList: newExistingFileList
            };
        });
    };
    
    addFileToList = (file, applicationId = null, listType = null) => {
        if (applicationId) {
            file.applicationId = applicationId;
        }
        
        if (listType === 'fileList') {
            this.setState(state => ({
                fileList: [file, ...state.fileList]
            }));
        }
        
        if (listType === 'existingFileList') {
            this.setState(state => ({
                existingFileList: [file, ...state.existingFileList]
            }));
        }
        
        if (listType === null) {
            this.setState(state => ({
                fileList: [file, ...state.fileList],
                existingFileList: [file, ...state.existingFileList]
            }))
        }
        return false;
    };
    
    restructureExistingFiles = (existingFiles, listType) => {
        if (existingFiles && listType === 'fileList') {
            const transformed = existingFiles.map(({fileName, date}) => {
                return (new File([""], fileName, {type: "text/plain", lastModifiedDate: date}));
            })
            return transformed;
        } else {
            const transformed = existingFiles.map(({fileName: name, id: uid, type, date, clientComment, comment}) => {
                return ({name, uid, type, date, clientComment, comment});
            })
            return transformed;
        }
    }
    
    addExistingFilesToList = (file, applicationId = null) => {
        const transformedFileList = this.restructureExistingFiles(file, 'fileList');
        transformedFileList.forEach(file => {
            this.addFileToList(file, null, 'fileList');
        })
        const transformedExistingFileList = this.restructureExistingFiles(file, 'existingFileList');
        transformedExistingFileList.forEach(file => {
            this.addFileToList(file, null, 'existingFileList');
        })
        return false;
    };
    
    uploadedDocumentsList = async id => {
        const {dispatch} = this.props
        try {
            const result = await dispatch(ApplicationsActions.getUploadedDocumentsList(id));
            const groupedDocumentList = _.groupBy(result.payload, "type");
            this.setState(() => ({
                groupedDocumentList
            }));
        } catch (e) {
            throw e
        }
    }
    
    orgStructureReadyToUpload = data => {
        const {orgStructure, orgStructureHtml, orgStructurePdf} = data;
        if (orgStructure && orgStructureHtml) {
            this.setState({
                orgStructure: orgStructure,
                orgStructureHtml: orgStructureHtml,
                orgStructurePdf: orgStructurePdf
            });
        }
    };
    
    startApplicationSigning = async authType => {
        const {dispatch} = this.props;
        
        switch (authType) {
            case LOGIN_TYPES.BIO_FACE:
                try {
                    await dispatch(KYCActions.startApplicationSigning(authType));
                    this.setState({
                        isBioFaceUploadModalOpen: true
                    });
                } catch (e) {
                }
                break;
            case LOGIN_TYPES.MOBILE:
            case LOGIN_TYPES.SMART_ID:
                try {
                    await dispatch(KYCActions.startApplicationSigning(authType));
                    this.setState({
                        nextAction: APP_STATES.APPLICATION_SIGNED
                    });
                } catch (e) {
                }
                break;
            default:
                break;
        }
    };
    
    onBioFaceDocUploadComplete = () => {
        this.setState({
            isBioFaceUploadModalOpen: false,
            nextAction: APP_STATES.UPLOAD_POWER_ATTORNEY,
            modalUpload: true,
            modalSubmitAction: KYCActions.uploadPowerOfAttorney
        });
    };
    
    onBioFaceAgreementComplete = () => {
        this.setState({
            isBioFaceUploadModalOpen: false,
            nextAction: APP_STATES.PENDING
        });
    };
    
    showApplicationDocument = () => {
        this.setState({
            nextAction: "StartApplicationSigning",
            applicationSigning: true
        });
    };
    
    startAgreementSigning = async authType => {
        const {dispatch} = this.props;
        switch (authType) {
            case LOGIN_TYPES.BIO_FACE:
                try {
                    await dispatch(KYCActions.startAgreementSigning(authType));
                    this.setState({
                        isBioFaceUploadModalOpen: true
                    });
                } catch (e) {
                }
                break;
            case LOGIN_TYPES.MOBILE:
            case LOGIN_TYPES.SMART_ID:
                try {
                    await dispatch(KYCActions.startAgreementSigning(authType));
                    this.setState({
                        nextAction: APP_STATES.ONBOARDING_COMPLETE
                    });
                } catch (e) {
                }
                break;
            default:
                break;
        }
    };
    
    successSigning = nextAction => {
        this.setState({
            signingData: null,
            successSigning: true,
            nextAction: nextAction
        });
    };
    
    successFinishFn = () => {
        this.setState({
            successFinish: true,
            signingData: null
        });
    };
    
    successRenewFinish = () => {
        this.setState({
            successRenewFinish: true,
            signingData: null
        });
    };
    
    continueApplication = () => {
        const {dispatch} = this.props,
            {nextAction} = this.state;
        if (nextAction === "OnboardingComplete") {
            this.setState({
                successSigning: true
            });
            setTimeout(this.checkState, 1000);
        } else {
            dispatch(KYCActions.continueApplication());
            this.setState({
                successSigning: false
            });
        }
    };
    
    reloadKYC = () => {
        const {dispatch} = this.props;
        localStorage.removeItem(STORAGE_ITEMS.SIGNIN_TOKEN);
        this.setState({
            signingData: null
        });
        dispatch(KYCActions.startKYC()).then(response => {
            if (response && response.payload) this.actionSwitch(response.payload);
        });
    };
    
    resetState = (afterSign = false, state) => {
        const newState = afterSign
            ? {
                nextAction: afterSign,
                modalUpload: null,
                modalUploadAppDocs: null,
                modalSubmitAction: null,
                fileList: [],
                existingFileList: [],
                orgStructure: null,
                data: null,
                signingData: null,
                reviewerComment: null
            }
            : {
                nextAction: null,
                modalUpload: null,
                modalUploadAppDocs: null,
                modalSubmitAction: null,
                fileList: [],
                existingFileList: [],
                orgStructure: null,
                data: null,
                signingData: null,
                documentId: null,
                reviewerComment: null
            };
        if (!afterSign && state !== "OnboardingComplete" && state !== "AgreementSigningStarted") {
            newState.successSigning = null;
        }
        if (!afterSign && state === "OnboardingComplete") {
            newState.successFinish = true;
        }
        if (!afterSign && state === 'RenewedKycCompleted') {
            newState.successRenewFinish = true;
        }
        
        this.setState(newState);
    };
    
    checkState = () => {
        const {dispatch} = this.props;
        
        dispatch(KYCActions.checkState()).then(response => {
            if (
                response?.type.toLowerCase().indexOf("success") > -1 &&
                (response?.payload?.availableActions?.length > 0 ||
                    response?.payload?.state === "OnboardingComplete")
            ) {
                dispatch(KYCActions.startKYC());
            }
        });
    };
    
    startOndatoBeneficiaryIdentification = () => {
        const {dispatch} = this.props;
        
        dispatch(KYCActions.startOndatoBeneficiaryIdentification());
    };
    
    actionSwitch = (payload = null) => {
        const applicationKYC = payload && payload !== "null" ? payload : this.props.applicationKYC;
        const signingData = applicationKYC?.applicationState?.signingData;
        const state =
            applicationKYC.applicationState && applicationKYC.applicationState.state
                ? applicationKYC.applicationState.state
                : applicationKYC.state;
        const prefillData =
            applicationKYC.applicationState && applicationKYC.applicationState.prefillData
                ? applicationKYC.applicationState.prefillData
                : applicationKYC.prefillData;
        let {nextAction, groupedDocumentList, applicationId} = this.state;
        let {applicationCompany} = this.props;
        let country =
            applicationCompany && applicationCompany.country
                ? applicationCompany.country.substr(0, 2)
                : "LT";
        let representative = applicationKYC.representative
            ? applicationKYC.representative
            : prefillData
                ? prefillData.representative
                : {};
        let documentId =
            applicationKYC.applicationState && applicationKYC.applicationState.documentId
                ? applicationKYC.applicationState.documentId
                : applicationKYC.documentId;
        let reviewerComment =
            applicationKYC.applicationState && applicationKYC.applicationState.reviewerComment
                ? applicationKYC.applicationState.reviewerComment
                : applicationKYC.reviewerComment;
        const applicationState = applicationKYC.applicationState || applicationKYC;
        let parsePhone = value => {
            if (!value) return value;
            const onlyNums = value.replace(/[^\d]/g, "");
            return `+${onlyNums}`;
        };
        this.setState({
            prefillData
        });
        
        if (nextAction !== "ApplicationSigned") this.resetState("", state);
        switch (state) {
            case "WaitingForPowerOfAttorney":
                this.setState({
                    nextAction: APP_STATES.UPLOAD_POWER_ATTORNEY,
                    modalUpload: true,
                    modalSubmitAction: KYCActions.uploadPowerOfAttorney
                });
                (groupedDocumentList.PowerOfAttorney && applicationId) &&
                this.addExistingFilesToList(groupedDocumentList.PowerOfAttorney, applicationId);
                break;
            case "WaitingForArticlesOfAssociation":
                this.setState({
                    nextAction: "UploadArticlesOfAssociation",
                    modalUpload: true,
                    modalSubmitAction: KYCActions.uploadArticlesOfAssociation //imones istatu ikelimas
                });
                (groupedDocumentList.ArticlesOfAssociation && applicationId) &&
                this.addExistingFilesToList(groupedDocumentList.ArticlesOfAssociation, applicationId);
                break;
            case "WaitingForWolfsbergQuestionnaire":
                this.setState({
                    nextAction: "UploadWolfsbergQuestionnaire", //kazkokio klausimyno ikelimas
                    modalUpload: true,
                    modalSubmitAction: KYCActions.uploadWolfsbergQuestionnaire
                });
                break;
            case "WaitingForBeneficiaryIdentification":
                this.setState({
                    nextAction: "UploadBeneficiaryDocuments", //beneficiary docs ikelimas
                    modalUpload: true,
                    modalSubmitAction: KYCActions.uploadBeneficiaryDocuments
                });
                if (groupedDocumentList.BeneficiaryIdentification && applicationId) {
                    this.addExistingFilesToList(groupedDocumentList.BeneficiaryIdentification, applicationId);
                }
                break;
            case "WaitingForOrganizationalChart":
                this.setState({
                    nextAction: "UploadOrganizationalChart", //org structure ikelimas
                    modalUpload: true,
                    modalSubmitAction: KYCActions.uploadOrganizationalChart
                });
                if (groupedDocumentList.OrganizationalChart && applicationId) {
                    this.addExistingFilesToList(groupedDocumentList.OrganizationalChart, applicationId);
                }
                break;
            case "WaitingForAdditionalDocuments":
                this.setState({
                    nextAction: "UploadAdditionalDocuments", //papildomu docs ikelimas
                    modalUpload: true,
                    modalSubmitAction: KYCActions.uploadAdditionalDocuments,
                    reviewerComment
                });
                (groupedDocumentList.AdditionalDocuments && applicationId) &&
                this.addExistingFilesToList(groupedDocumentList.AdditionalDocuments, applicationId);
                break;
            case "WaitingForBeneficiaryDocuments":
                this.setState({
                    nextAction: "UploadAdditionalDocuments", //papildomu docs ikelimas
                    modalUpload: true,
                    modalSubmitAction: KYCActions.uploadAdditionalDocuments,
                    reviewerComment
                });
                (groupedDocumentList.BeneficiaryDocuments && applicationId) &&
                this.addExistingFilesToList(groupedDocumentList.BeneficiaryDocuments, applicationId);
                break;
            case "UserFillingApplication":
                const {dispatch} = this.props;
                const dataAddress = prefillData.addressSplit
                        ? {
                            addressCountry: prefillData.addressSplit.country || country,
                            addressCity: prefillData.addressSplit.city,
                            addressStreet: prefillData.addressSplit.street,
                            addressHouse: prefillData.addressSplit.house,
                            addressFlat: prefillData.addressSplit.flat
                        }
                        : {},
                    clientCeoName = {
                        clientCeoName: prefillData.managerFirstName,
                        clientCeoSurname: prefillData.managerLastName
                    };
                const whoOpenAccount =
                    representative && prefillData.managerCode !== representative.code ? "CMP2" : "CMP1";
                
                let data = Object.assign(
                    initData,
                    getPrefilledDataObject(
                        prefillData,
                        applicationCompany,
                        whoOpenAccount,
                        parsePhone,
                        dataAddress,
                        clientCeoName,
                        representative
                    )
                );
                dispatch(FormStepsActions.getFormApplicationAction()).then(response => {
                    if (response && response.payload && response.payload.data && response.error !== "") {
                        const parsedData =
                            typeof response.payload.data === "string"
                                ? JSON.parse(response.payload.data)
                                : response.payload.data;
                        
                        if (parsedData.personData) {
                            const {companyFunds, clientPoliticsPosition, clientCeo} = parsedData.personData;
                            
                            Object.keys(companyFunds[0]?.data).forEach(
                                objKey =>
                                    (parsedData.personData.companyFunds[0].data[objKey] =
                                        companyFunds[0]?.data[objKey] == true)
                            );
                            parsedData.personData.companyFunds[0].companyFundsValid = Object.keys(
                                companyFunds[0]?.data
                            )
                                .map(keyItem => {
                                    return companyFunds[0]?.data[keyItem];
                                })
                                .some(item => item);
                            
                            Object.keys(clientPoliticsPosition?.[0]?.data || {}).forEach(
                                objKey =>
                                    (parsedData.personData.clientPoliticsPosition[0].data[objKey] =
                                        clientPoliticsPosition[0]?.data[objKey] == true)
                            );
                            
                            if (parsedData?.personData?.clientPoliticsPosition?.[0]?.clientPoliticsValid) {
                                parsedData.personData.clientPoliticsPosition[0].clientPoliticsValid = Object.keys(
                                    clientPoliticsPosition?.[0]?.data || {}
                                )
                                    .map(keyItem => {
                                        return clientPoliticsPosition[0]?.data[keyItem];
                                    })
                                    .some(item => item);
                            }
                            
                            if (parsedData.personData.clientBeneficiaries[0]?.data) {
                                const {
                                    otherClientBenefRegCountry,
                                    tradeSecur,
                                    otherClientBenefRegCountSch
                                } = parsedData.personData.clientBeneficiaries[0].data;
                                parsedData.personData.clientBeneficiaries[0].data.otherClientBenefRegCountry =
                                    otherClientBenefRegCountry == true ? 1 : 0;
                                parsedData.personData.clientBeneficiaries[0].data.tradeSecur =
                                    tradeSecur == true ? 1 : 0;
                                parsedData.personData.clientBeneficiaries[0].data.otherClientBenefRegCountSch =
                                    otherClientBenefRegCountSch == true ? 1 : 0;
                            }
                            if (parsedData.personData.clientProfile[0]?.data) {
                                const {
                                    directMarketing,
                                    clientPoliticsMember,
                                    requireBusinessLicense,
                                    amlRulesLeg,
                                    amlProcedure
                                } = parsedData.personData.clientProfile[0].data;
                                parsedData.personData.clientProfile[0].data.directMarketing =
                                    directMarketing == true ? 1 : 0;
                                parsedData.personData.clientProfile[0].data.clientPoliticsMember =
                                    clientPoliticsMember == true ? 1 : 0;
                                parsedData.personData.clientProfile[0].data.requireBusinessLicense =
                                    requireBusinessLicense == true ? 1 : 0;
                                parsedData.personData.clientProfile[0].data.amlProcedure =
                                    amlProcedure == true ? 1 : 0;
                                parsedData.personData.clientProfile[0].data.amlRulesLeg =
                                    amlRulesLeg == true ? 1 : 0;
                            }
                            if (parsedData.personData.mainCustom[0]?.data) {
                                const {customerEmpty, retail} = parsedData.personData.mainCustom[0].data;
                                parsedData.personData.mainCustom[0].data.customerEmpty = customerEmpty == true;
                                parsedData.personData.mainCustom[0].data.retail = retail == true;
                            }
                            if (clientCeo[0]?.data) {
                                parsedData.personData.clientCeo[0].data.otherCeoCitizien =
                                    clientCeo[0]?.data.otherCeoCitizien == true ? 1 : 0;
                                parsedData.personData.clientCeo[0].data.otherCeoCitizienSch =
                                    clientCeo[0]?.data.otherCeoCitizienSch == true ? 1 : 0;
                            }
                        }
                        this.setState({
                            nextAction: "UserFillingApplication",
                            data: Object.assign(data, parsedData.personData),
                            initialStep: parsedData.currentStep
                        });
                    } else {
                        this.setState({
                            data: data,
                            nextAction: "UserFillingApplication"
                        });
                    }
                });
                break;
            case APP_STATES.APP_SUBMITTED:
                const hasAppUploadAction = applicationKYC.applicationState.availableActions.find(
                    action => action.name === APP_ACTIONS.UPLOAD_SIGNED_APP
                );
                this.setState({
                    nextAction: hasAppUploadAction
                        ? APP_STATES.START_APPLICATIONS_SIGNING
                        : APP_STATES.SHOW_APP_DOCUMENTS,
                    applicationSigning: hasAppUploadAction ? true : false,
                    documentId: documentId
                });
                break;
            case "ApplicationSigningStarted":
                this.setState({
                    nextAction: "Continue",
                    documentId: documentId,
                    signingData
                });
                break;
            case "ApplicationSigned":
                this.setState({
                    nextAction: "Continue"
                });
                this.continueApplication();
                break;
            case APP_STATES.WAITING_PRODUCT_AGREEMENT_SIGNATURE:
                this.setState({
                    nextAction: APP_STATES.AGREEMENT_SIGNING_STARTED,
                    applicationSigning: true,
                    documentId: documentId
                });
                break;
            case APP_STATES.AGREEMENT_SIGNING_STARTED:
                // bioface auth doesnt have signingData we dont do next state on bio face
                const isBioFaceSignin = !applicationKYC?.applicationState?.signingData;
                this.setState({
                    nextAction: isBioFaceSignin
                        ? APP_STATES.AGREEMENT_SIGNING_STARTED
                        : APP_STATES.ONBOARDING_COMPLETE,
                    documentId: documentId,
                    signingData: isBioFaceSignin ? null : signingData
                });
                break;
            case "OnboardingComplete":
                this.setState({
                    successFinish: true
                });
                break;
            case "AgreementsSigned":
                this.setState({
                    nextAction: "OnboardingComplete"
                });
                break;
            case "StartApplicationSigning":
                break;
            case "WaitingForApplicationDocuments":
                this.setState({
                    nextAction: "UploadApplicationDocument", //application dokumento ikelimas
                    modalSubmitAction: KYCActions.uploadApplicationDocument,
                    applicationState,
                    modalUploadAppDocs: true
                });
                //hack for complete flow need to be fixed later
                // window.location.reload();
                break;
            case "RenewedKycCompleted":
                this.setState({
                    successRenewFinish: true
                });
                break;
            default:
                this.setState({
                    nextAction: "Pending"
                });
                break;
        }
    };
    
    onStepSubmit = (values, step) => {
        const savedValues = Object.assign({}, values);
        
        Object.keys(savedValues).forEach(item => {
            if (parseInt(item) || parseInt(item) === 0) delete savedValues[item];
        });
        if (checkJsonExist(savedValues, "Approve")) delete savedValues.Approve;
    };
    
    onSubmit = values => {
        const {dispatch} = this.props;
        this.onStepSubmit(values);
        this.setState({
            data: values
        });
        
        let newValues = JSON.parse(JSON.stringify(values));
        newValues = remapNewValues(newValues);
        
        //Remap all data
        const finalData = JSON.parse(
            JSON.stringify(newValues, (key, value) => {
                if (value === 0 || value === false) return "0";
                if (value === 1 || value === true) return "1";
                if (typeof value === "number") return value.toString();
                if (value === null) return "";
                return value;
            })
        );
        dispatch(KYCActions.submitApplication({data: {personData: finalData}}));
    };
    
    goToDocApprovalState = () => {
        this.setState({
            modalUploadAppDocs: false,
            nextAction: "Pending",
            modalSubmitAction: null
        });
    };
    
    handleBioDocModalClose = async () => {
        const {dispatch} = this.props;
        await dispatch(KYCActions.cancelUploadDocument());
        this.setState({isBioFaceUploadModalOpen: false});
    };
    
    // calls user innactive modal
    handleOnIdle = () => {
        if (this.state.isInactiveModalOpen) return;
        this.setState({
            isInactiveModalOpen: true
        });
    };
    
    render() {
        const {sendKYC, send, applicationCompany, applicationKYC, language} = this.props;
        const classificators = getClassificators();
        const classificatorsConst = getClassificatorsConst();
        
        if (sendKYC || send) return (
            <div className="main_inner">
                <ContentLoader/>
            </div>
        );
        
        const FILE_LINK_INFO = {
            [LANGUAGES.LT]: `<a
      href=${process.env.PUBLIC_URL}/doc/Igaliojimas_saskaitos_atidarymui_2022.doc
      download="Igaliojimas_saskaitos_atidarymui_2022.doc"
    >
      <DownloadOutlined className="mr-2" />
      ${trb(i18.Buttons.ProvideAuthTemplate)}
    </a>`,
            [LANGUAGES.EN]: `<a
      href=${process.env.PUBLIC_URL}/doc/Igaliojimas_saskaitos_atidarymui_2022_EN.docx
      download="PoA_Template_for_account_opening_2022.docx"
    >
      <DownloadOutlined className="mr-2" />
      ${trb(i18.Buttons.ProvideAuthTemplate)}
    </a>`
        };
        
        const mapData = getMapDataObject(
            classificators,
            classificatorsConst,
            applicationCompany,
            this.state.prefillData,
            this.state.data
        );
        
        const {
            modalUpload,
            modalUploadAppDocs,
            nextAction,
            fillOrgStructure,
            data,
            signingData,
            documentId,
            finalData,
            successSigning,
            successFinish,
            successRenewFinish,
            initialStep,
            reviewerComment,
            fileList,
            orgStructure,
            orgStructureHtml,
            isBioFaceUploadModalOpen,
            existingFileList,
            showPdf
        } = this.state;
        const sanitizer = DOMPurify.sanitize;
        
        const decodeBase64String = () => {
            return decodeURIComponent(escape(window.atob(reviewerComment)));
        };
        
        const renderUploadDragger = applicationId => {
            return (
                <>
                    <Upload.Dragger
                        beforeUpload={file => this.addFileToList(file, applicationId)}
                        onRemove={this.removeFileFromList}
                        fileList={existingFileList}
                        onPreview={file => this.filePreview(file)}
                        className="mb-5 py-3"
                        accept=".pdf,.jpg,.png,.bmp,.jpeg"
                        multiple
                    >
                        {false && (
                            <div className="eb_content_subtitle text-center mx-1">
                                {trb(translationGroups.ActionsTitle + nextAction)}
                            </div>
                        )}
                        {!showPdf &&
                            <p className="ant-upload-drag-icon">
                                <PlusOutlined/>
                            </p>
                        }
                    </Upload.Dragger>
                    {
                        (showPdf && documentId) &&
                        <Modal
                            visible={true}
                            onCancel={() => this.filePreview()}
                            width="100%"
                            footer={null}
                        >
                            <PdfDocView
                                documentId={documentId}
                            />
                        </Modal>
                    }
                </>
            );
        };
        
        if (nextAction === APP_STATES.USER_FILLING_APPLICATION) {
            return <Redirect to={routerPath.newKycSme.step1}/>
        }
        
        return (
            <>
                {this.state.data && (
                    <IdleTimer
                        timeout={this.state.timeoutPeriod}
                        onIdle={this.handleOnIdle}
                        debounce={15000} // checks if user is in idle state every 15 seconds
                    />
                )}
                {this.state.isInactiveModalOpen && (
                    <UserActive
                        data={this.state.data}
                        step={this.state.currentStep}
                        open={this.state.isInactiveModalOpen}
                        onClose={() =>
                            this.setState({
                                isInactiveModalOpen: false
                            })
                        }
                    />
                )}
                {modalUpload && (
                    <div className="w-100">
                        <div className="w-100 d-flex justify-content-between">
              <span className="eb_fs_16">
                {trb(translationGroups.Messages + nextAction)}
                  {reviewerComment && (
                      <span>
                    <br/>
                    <br/>
                          {parse(sanitizer(decodeBase64String()))}
                  </span>
                  )}
              </span>
                            {/* this means current action is WaitingForPowerOfAttorney and should
              show the download doc btn */}
                            {nextAction === APP_STATES.UPLOAD_POWER_ATTORNEY && (
                                <div dangerouslySetInnerHTML={{__html: FILE_LINK_INFO[language]}}/>
                            )}
                        </div>
                        <div className="w-100 mb-3 upload_card">
                            {nextAction === "UploadOrganizationalChart" && (
                                <div className="pb-3 row">
                                    <Button
                                        className={fillOrgStructure ? "" : "my-active-link"}
                                        type="link"
                                        size="small"
                                        onClick={() => this.setState({fillOrgStructure: false})}
                                    >
                                        {trb(i18.ApplicationsLabels.UploadOrgStructure)}
                                    </Button>
                                    <Button
                                        className={fillOrgStructure ? "my-active-link" : ""}
                                        type="link"
                                        size="small"
                                        onClick={() => this.setState({fileList: [], fillOrgStructure: true})}
                                    >
                                        {trb(i18.ApplicationsLabels.AddOrgStructure)}
                                    </Button>
                                </div>
                            )}
                            {nextAction === "UploadOrganizationalChart" && fillOrgStructure ? (
                                <FillOrgStructure
                                    applicationCompany={applicationCompany}
                                    orgStructure={orgStructure}
                                    beforeUpload={this.orgStructureReadyToUpload}
                                />
                            ) : (
                                renderUploadDragger()
                            )}
                        </div>
                        <div className="w-100 text-right">
                            <p className="agree-on-correct-document">{trb(i18.Labels.AgreeOnCorrectDocument)}</p>
                            <Button
                                type="primary"
                                className="btn-big"
                                disabled={(existingFileList.length === 0 && fileList.length === 0) && (!orgStructure || !orgStructureHtml)}
                                onClick={() => this.uploadSubmit()}
                                size="large"
                            >
                                {trb(i18.Buttons.Upload)}
                            </Button>
                        </div>
                        {false && nextAction === "UploadBeneficiaryDocuments" && (
                            <>
                                <div className="eb_content_subtitle text-center mb-5 mx-1 text-gray-basic">
                                    {trb(i18.Labels.Or)}
                                </div>
                                <div beforeUpload={this.addFileToList} className="custom_upload text-center">
                                    <Button
                                        type="primary"
                                        size="large"
                                        style={{padding: 15}}
                                        onClick={this.startOndatoBeneficiaryIdentification}
                                    >
                                        {trb(i18.Buttons.OndatoIdentification)}
                                    </Button>
                                </div>
                            </>
                        )}
                    </div>
                )}
                {modalUploadAppDocs && (
                    <UploadRequestedAppDocs fileList={this.state.list}
                                            goToDocApprovalState={this.goToDocApprovalState}/>
                )}
                {(signingData || successSigning) &&
                    nextAction !== "AgreementSigningStarted" &&
                    !successFinish &&
                    documentId && (
                        <div className="col-12">
                            {signingData && !this.state.successSigning && (
                                <SigningOld
                                    scaTimeout={signingData.scaTimeout}
                                    controlCode={signingData.controlCode}
                                    document={signingData.document}
                                    resetAll={() => this.reloadKYC()}
                                    success={() =>
                                        nextAction === APP_STATES.ONBOARDING_COMPLETE
                                            ? this.successFinishFn()
                                            : nextAction === APP_STATES.RENEW_COMPLETE
                                                ? this.successRenewFinish() : this.successSigning(nextAction)
                                    }
                                    applicationSign
                                />
                            )}
                            <PdfDocView
                                documentId={documentId}
                                onClick={this.continueApplication}
                                showButtons={successSigning}
                                buttonTitle={trb(i18.Buttons.NextStep)}
                            />
                        </div>
                    )}
                {documentId && nextAction === "StartApplicationSigning" && (
                    <div className="col-12">
                        <PdfDocView
                            documentId={documentId}
                            onClick={this.startApplicationSigning}
                            showButtons={true}
                            buttonTitle={trb(i18.Buttons.ShowApplicationDocument)}
                            authTypes={applicationKYC?.authTypes || applicationKYC?.applicationState?.authTypes}
                        />
                    </div>
                )}
                {documentId && nextAction === "AgreementSigningStarted" && (
                    <div className="col-12">
                        <PdfDocView
                            documentId={documentId}
                            onClick={this.startAgreementSigning}
                            showButtons={true}
                            buttonTitle={trb(i18.Buttons.ShowApplicationDocument)}
                            authTypes={applicationKYC?.authTypes || applicationKYC?.applicationState?.authTypes}
                        />
                    </div>
                )}
                {nextAction === "Pending" && (
                    <Result
                        title={trb(translationGroups.Actions + nextAction)}
                        subTitle={trb(translationGroups.ActionsDescriptions + nextAction)}
                        icon={<></>}
                        extra={
                            <Button
                                onClick={() => {
                                    this.checkState();
                                }}
                                size="large"
                                type="primary"
                            >
                                {trb(translationGroups.ActionsButtons + nextAction)}
                            </Button>
                        }
                    />
                )}
                {successFinish && <KycComplete translation={i18.Labels.OnboardingComplete}
                                               linkTranslation={i18.Labels.OnboardingCompleteLinkName}/>}
                {successRenewFinish && <KycComplete translation={i18.Labels.PeriodicReviewComplete}/>}
                {nextAction === "ShowApplicationDocument" && (
                    <KYCFormSwitchWithSteps
                        dispatch={this.props.dispatch}
                        decorators={[decorators]}
                        approveSubmitText={i18.NotificationMessages.KYCApproveSubmit}
                        mapData={mapData}
                        initialData={data}
                        submit={this.onSubmit}
                        finalData={finalData}
                        onStepSubmit={this.onStepSubmit}
                        initialStep={initialStep}
                        afterLastStep={
                            nextAction === APP_STATES.SHOW_APP_DOCUMENTS ? (
                                <StartDocSigning onClick={this.showApplicationDocument}/>
                            ) : null
                        }
                    />
                )}
                {isBioFaceUploadModalOpen && (
                    <BioDocUploadModal
                        onComplete={
                            nextAction === APP_STATES.AGREEMENT_SIGNING_STARTED
                                ? this.onBioFaceAgreementComplete
                                : this.onBioFaceDocUploadComplete
                        }
                        onClose={this.handleBioDocModalClose}
                        nextAction={nextAction}
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    const {applicationKYC, sendKYC, send, applicationCompany} = state.KYCReducers,
        {language} = state.languageReducer;
    
    return {
        applicationKYC,
        sendKYC,
        send,
        applicationCompany,
        language
    };
}

const connectedApplicationKYCSmeContainer = withRouter(
    connect(mapStateToProps)(ApplicationKYCSmeContainer)
);
export {connectedApplicationKYCSmeContainer as ApplicationKYCSmeContainer};
